import api from 'Application/api/api';

const confirmUploadedFilesForDistanceProcedure = (
    driverLicenseControlId,
    cancelToken = null,
) =>
    api.post(
        `/measures/vehicles/driver-licenses/controls/${driverLicenseControlId}/driver-license/distance-check/confirm-uploaded-files`,
        {},
        {
            cancelToken,
        },
    );

export default confirmUploadedFilesForDistanceProcedure;
